import domService from '../../../../../../../services/DomService';
import IdReader from './IdReader';
import { reportError } from '../../../../../../../services/ErrorReporting';
import snapshotsService from '../../../../../../../services/SnapshotsService';
import { t } from '../../../../../../../services/i18nService';

const snapshotsPlugin = {
    register(globalCK) {
        if (globalCK.plugins.get('ia-snapshots-tool')) {
            return;
        }

        globalCK.plugins.add('ia-snapshots-tool', {
            icons: '',
            init: (editorInstance) => { this.init(editorInstance); },
        });
    },

    init(editorInstance) {
        const isPreRender = domService.hasClass(editorInstance.element.$, 'preRender');
        editorInstance.addCommand('openSnapshotsTool', {
            exec: (editor) => { editor.snapshotsTriggerFunction(editor); },
        });
        editorInstance.ui.addButton('IA Snapshots', {
            label: t('ckeditor.snapshots.toolbarButtonText'),
            command: 'openSnapshotsTool',
            toolbar: 'snapshots',
        });

        if (!isPreRender) {
            const instanceName = editorInstance.name;
            const handle = snapshotsService.startInterval(
                IdReader.getQuestionId(editorInstance),
                IdReader.getInteractionId(editorInstance),
                () => {
                    try {
                        // This is to prevent potential memory leaks if using a direct reference to the editorInstance.
                        const editor = window.CKEDITOR.instances[instanceName];
                        return editor.getData();
                    } catch (error) {
                        reportError(error);
                        clearInterval(handle);
                    }
                    return undefined;
                },
            );

            editorInstance.on('instanceReady', () => {
                snapshotsService.storeSnapshotIfChanged(
                    IdReader.getQuestionId(editorInstance),
                    IdReader.getInteractionId(editorInstance),
                    () => {
                        try {
                            // This is to prevent potential memory leaks if using a direct reference to the editorInstance.
                            const editor = window.CKEDITOR.instances[instanceName];
                            return editor.getData();
                        } catch (error) {
                            reportError(error);
                            clearInterval(handle);
                        }
                        return undefined;
                    },
                );
            });

            editorInstance.on('destroy', () => {
                clearInterval(handle);
            });
        }
    },
};

export default snapshotsPlugin;
